import React, { useState, useRef, useEffect } from "react";

import { Typography, AutoComplete, Row, Input, Icon, message, Select, Divider, Button } from "antd";

import { searchCustomersApi, fetchLscCustomer, sendLoginOTPApi, verifyOTPApi } from "utils/apiService";
import { countries as countryList } from "constants/CountryList";

import avatarSmall from "media/avatarMed.svg";
import cardSmall from "media/cardIllustrationFilled.svg";
import { backgroundImage } from "media/posBackground.svg";

import OtpInput from "react-otp-input";

const { Text } = Typography;
const { Option } = AutoComplete;

const SearchUser = ({ ...props }) => {
	const [customerList, setCustomerList] = useState([]);
	const [countryCode, setCountryCode] = useState(`${JSON.parse(localStorage.getItem("countryData"))?.isd_code}`);
	const customerSearchRef = useRef(null);

	const [selectedCustomer, setSelectedCustomer] = useState();
	const [otpSent, setOTPSent] = useState(false);
	const [otp, setOTP] = useState();

	const [verifyCustomer, setVerifyCustomer] = useState(false);

	const searchCustomer = (v) => {
		searchCustomersApi({
			requestData: {
				// country_code: countryCode,
				search_key: v,
			},
			res200Callback: (res) => {
				setCustomerList(res.data.search_results);
			},
		});
	};

	const renderOption = (item) => {
		return (
			<Option key={item.key} value={item.key + "&" + item.name + "&" + item.type}>
				<Row type="flex" align="middle">
					<img
						src={item.type === "Contact Number" ? avatarSmall : cardSmall}
						style={{
							width: "48px",
							height: "48px",
							paddingRight: 16,
						}}
						alt={"Illustration"}
					/>
					<div style={{ display: "flex", flexDirection: "column", marginRight: 20 }}>
						{item.type === "Contact Number" && (
							<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "24px", color: "#181818" }}>{item.name}</Text>
						)}
						<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px" }}>{item.key}</Text>
					</div>
				</Row>
			</Option>
		);
	};

	useEffect(() => {
		if (otp?.length === 6) {
			verifyOTPApi({
				requestData: { country_code: countryCode, contact_number: selectedCustomer?.split("&")[0], otp: otp },
				res200Callback: (res) => {
					if (res?.data.verified === true) {
						localStorage.setItem(
							"verified",
							("+" + countryCode + "-" + selectedCustomer?.split("&")[0]).split("").reduce((a, b) => {
								a = (a << 5) - a + b.charCodeAt(0);
								return a & a;
							}, 0)
						);
						debugger;
						props.history.push(`merge-update-cards/contact/${countryCode}/${selectedCustomer?.split("&")[0]}`);
					} else message.error("Please enter correct OTP!");
				},
			});
		}
	}, [otp]);

	const sendOTP = (contact) => {
		sendLoginOTPApi({
			requestData: {
				country_code: countryCode,
				contact_number: contact,
			},
			res200Callback: () => {
				message.info("OTP is sent to customer's contact number.");
			},
		});
	};

	// useEffect(() => {
	// 	if (selectedCustomer) {
	// 		sendOTP(selectedCustomer?.split("&")[0]);
	// 	}
	// }, [selectedCustomer]);

	useEffect(() => {
		localStorage.removeItem("verified");
	}, []);

	return (
		<>
			{/* {!verifyCustomer && <img src={backgroundImage} style={{ width: "1152px", height:"650px", position: "absolute" }} />} */}

			<div style={{ position: "relative", top: verifyCustomer ? "50px" : "100px" }}>
				<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
					<div style={{ display: "flex", flexDirection: "column", justifyContent: "center", position: "relative" }}>
						{verifyCustomer && (
							<Icon
								type="arrow-left"
								style={{
									// height: "16px",
									fontSize: "24px",
									paddingRight: "16px",
									position: "absolute",
									transform: "translateX(-50%)",
									left: "-140px",
								}}
								onClick={() => props.history.go(0)}
							/>
						)}
						<Text
							style={{
								fontStyle: "normal",
								fontWeight: "bolder",
								fontSize: !verifyCustomer ? "40px" : "24px",
								lineHeight: !verifyCustomer ? "56px" : "40px",
								color: "#181818",
								textAlign: "center",
							}}>
							{!verifyCustomer ? "Banat Al Nujoom Customer Support" : "Verify Customer"}
						</Text>
						{!verifyCustomer && (
							<Text style={{ fontStyle: "normal", fontSize: "16px", lineHeight: "24px", color: "#747474", textAlign: "center" }}>
								Search Phone Number (971555555555) or Banat Al Nujoom Card (10019865)
							</Text>
						)}
					</div>
					{!verifyCustomer ? (
						<div style={{ display: "flex", alignItems: "center" }}>
							{/* <Select
							showSearch
							allowClear
							style={{
								display: "flex",
								alignItems: "center",
								margin: "16px 16px 0 0",
								justifyContent: "space-between",
								width: 200,
								border: "1px solid #D9D9D9",
								borderRadius: "5px",
								height: "48px",
								textOverflow: "ellipsis",
							}}
							defaultValue={"971"}
							placeholder="Country Code"
							optionFilterProp="children"
							onChange={(value) => setCountryCode(value)}
							filterOption={(input, option) => option.props.children.indexOf(input) >= 0}>
							{countryList.map(
								(country) =>
									country.shortName === "AE" && (
										<Option key={country.phone} value={country.phone}>
											{`${country.emoji} ${country.shortName} (+${country.phone})`}
										</Option>
									)
							)}
						</Select> */}
							<AutoComplete
								dropdownStyle={{ width: 250, border: "1px solid #D9D9D9", borderRadius: "5px" }}
								size="large"
								style={{ width: 500, height: 48, marginTop: 24 }}
								onSearch={(str) => {
									str.length >= 7 && searchCustomer(str);
									customerSearchRef.current = str;
								}}
								onSelect={(v) => {
									if (v?.split("&")[2] === "Contact Number") {
										setSelectedCustomer(v);
										setVerifyCustomer(true);
									} else {
										props.history.push(`merge-update-cards/card/${countryCode}/${v?.split("&")[0]}`);
									}
								}}
								optionLabelProp="value"
								dataSource={customerList.map(renderOption)}>
								<Input
									style={{ width: 500, height: 48, border: "1px solid #D9D9D9", borderRadius: "5px" }}
									placeholder="Search Customer by Phone Number or Banat Al Nujoom Card"
									maxLength={
										JSON.parse(localStorage.getItem("countryData"))?.isd_code?.length +
										JSON.parse(localStorage.getItem("countryData"))?.contact_number_length
									}
									suffix={<Icon type="search" />}
									// onKeyPress={(e) => {
									// 	if (e.key === "Enter") {
									// 		fetchLscCustomer({
									// 			requestData: {
									// 				country_code: countryCode,
									// 				contact_number: customerSearchRef.current,
									// 			},
									// 			res200Callback: (res) => {
									// 				setSelectedCustomer(res.data.contact_number + "&" + res.data.name);
									// 				setVerifyCustomer(true);
									// 			},
									// 			resErrorCallback: () => {
									// 				message.error("No such number exist, ask user to login in Banat Al Nujoom using this number.");
									// 			},
									// 		});
									// 	}
									// }}
								/>
							</AutoComplete>
						</div>
					) : (
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								width: 500,
								background: "#FFFFFF",
								padding: 16,
								marginTop: 24,
							}}>
							<img
								src={avatarSmall}
								style={{
									width: "80px",
									height: "80px",
								}}
								alt={"Illustration"}
							/>
							<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "24px", color: "#181818", marginTop: 16 }}>
								{selectedCustomer?.split("&")[1] || "Unknown User"}
							</Text>
							<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px" }}>
								{/* +{countryCode}- */}
								{selectedCustomer?.split("&")[0]}
							</Text>
							<Divider />
							<div style={{ display: "flex", flexDirection: "column" }}>
								{otpSent ? (
									<>
										<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#181818" }}>
											We've sent an OTP to Customer's Phone Number
										</Text>
										<OtpInput
											value={otp}
											onChange={(otp) => setOTP(otp)}
											isInputNum={true}
											numInputs={6}
											containerStyle={{ margin: "16px 0" }}
											inputStyle={{ width: 69, height: 48, border: "1px solid #AAAAAA", boxSizing: "border-box", borderRadius: "4px" }}
											focusStyle={{ border: "1px solid #fec708" }}
											separator={<span style={{ marginRight: "12px" }}></span>}
										/>
										<Text
											onClick={() => sendOTP(selectedCustomer?.split("&")[0])}
											style={{
												fontStyle: "normal",
												fontWeight: "normal",
												fontSize: "14px",
												lineHeight: "22px",
												color: "#fec708",
												textAlign: "center",
												cursor: "pointer",
											}}>
											Resend OTP
										</Text>
									</>
								) : (
									<div
										style={{
											display: "flex",
											justifyContent: "center",
										}}>
										<Button
											style={{
												padding: "8px 16px",
												background: "#fec708",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												color: "#ffffff",
											}}
											onClick={() => {
												sendOTP(selectedCustomer?.split("&")[0]);
												setOTPSent(true);
											}}>
											Send OTP
										</Button>
									</div>
								)}
								<Divider>OR</Divider>
								<Text
									onClick={() => {
										localStorage.setItem(
											"verified",
											("+" + countryCode + "-" + selectedCustomer?.split("&")[0]).split("").reduce((a, b) => {
												a = (a << 5) - a + b.charCodeAt(0);
												return a & a;
											}, 0)
										);
										props.history.push(`merge-update-cards/contact/${countryCode}/${selectedCustomer?.split("&")[0]}`);
									}}
									style={{
										fontStyle: "normal",
										fontWeight: "normal",
										fontSize: "14px",
										lineHeight: "22px",
										color: "#fec708",
										textAlign: "center",
										padding: "0 70px",
										cursor: "pointer",
									}}>
									The phone number provided is the customer's old number, which is no longer in use.
								</Text>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default SearchUser;
